export const searchBoxStyles: any = () => ({
  root: {
    width: '97%'
  },
  field: [
    {
      paddingLeft: 10
    },
    {
      selectors: {
        ':focus': {
          outline: 'none !important'
        }
      }
    }
  ]
})